import { rgba } from 'polished';

const styles = theme => ({
  root: {
    flex: 1,
    position: 'relative',
    display: 'flex',
    margin: [0, 'auto'],
    maxWidth: 1000,
    width: '100%'
  },
  frame: {
    position: 'absolute',
    zIndex: 1,
    left: 10,
    right: 10,
    top: 0,
    bottom: 0,
    outline: `2px solid ${theme.color.background.dark}`,
    outlineOffset: 2,
    backgroundColor: rgba(theme.color.background.dark, theme.color.alpha)
  },
  content: {
    position: 'relative',
    zIndex: 2,
    flex: 1,
    margin: [12, 16],
    padding: [0, 8, 0, 0],
    textAlign: 'center',
    scrollbarWidth: 'thin',
    scrollbarColor: `${theme.color.secondary.main} transparent`,

    '& > *:last-child, & > article > *:last-child': {
      marginBottom: 0
    },
    '& p, & h1, & h2, & h3, & ul, & ol': {
      marginLeft: 'auto',
      marginRight: 'auto'
    }
  },

  '@media screen and (min-width: 768px)': {
    root: {
      minHeight: 1
    },
    frame: {
      left: 12,
      right: 12,
      top: 0,
      bottom: 0
    },
    content: {
      overflowX: 'hidden',
      overflowY: 'auto',
      margin: [16, 20],
      padding: [0, 6, 0, 0],

      '& img': {
        maxWidth: '100%'
      }
    }
  },

  '@media screen and (min-width: 1025px)': {
    content: {
      margin: [20, 24],
      padding: [0, 6, 0, 0]
    }
  }
});

export { styles };
